<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />

			<div class="flex justify-between items-end mt-3">
				<div class="flex items-end">
					<h3 class="font-bold">{{models.name}}</h3>
					<span class="text-primary ml-3 font-bold">{{models.tier && models.tier.name}}</span>
				</div>
				<div class="history">
					<router-link :to="`/${config.uri}/${$route.params.id}/history`" class="font-bold mr-3">
						History Campaign
					</router-link>
					<router-link :to="`/${config.uri}/${$route.params.id}/point-history`" class="font-bold mr-3">
						History Point
					</router-link>
					<router-link :to="`/${config.uri}/${$route.params.id}/coin-history`" class="font-bold">
						History Coin
					</router-link>
				</div>
			</div>
			<div class="w-full my-5 flex flex-col lg:flex-row justify-between">
				<div class="w-full lg:w-4/12 border-solid border-0 border-grey lg:border-r">
					<div class="field">
						<div class="flex items-center">
							<div class="w-48 h-32 mr-3">
								<img class="h-full w-full object-cover bg-grey rounded-lg" :src="getUrlOfFile(models.image)" alt="image-product">
							</div>
							<div class="description">
								<a class="text-base">{{models.email}}</a> 
								<span class="mx-1"></span>
								<feather-icon @click="showPopUp()" icon="EditIcon" svgClasses="w-5 h-5 mr-3 stroke-current cursor-pointer" />
								<br>
								<small class="text-sm" v-if="models.requestChangeEmail">(Change Email Request: {{models.requestChangeEmail}})</small> 

								<p class="text-base my-1">Birth date: {{models.bod ? moment(models.bod).format('DD-MMM-YYYY') : '-'}}</p>
								<p class="text-base mb-1">{{contentTypes}}</p>
                <vs-divider />
                <p class="text-base mb-1">
                  <strong>Status</strong>:
                  {{models.maritalStatusText ? models.maritalStatusText : '-'}}
                </p>
								<p v-if="models.communities" class="text-base mb-1">
									<strong>Community</strong>:
									<template v-if="models.communities.length">
										<template v-for="v in models.communities">
											{{v.community ? v.community.name : "-"}}
										</template>
									</template>
									<template v-else>
										-
									</template>
								</p>
								<p class="text-base my-1 font-bold" :class="[ isVerified === false || isBanned || isSuspend ? 'text-danger' : isVerified === true ? 'text-success' : 'text-warning']">{{isVerifiedText}}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="w-full lg:w-3/12 flex flex-col justify-evenly border-solid border-0 border-grey lg:border-r my-3 lg:my-0">
					<div class="field">
						<label class="text-base">Address</label>
						<p class="text-base font-bold">
							{{models.address || '-'}}{{models.city && `, ${models.city}`}}{{models.province && `, ${models.province}`}}
						</p>
					</div>
					<div class="field">
						<label class="text-base">Phone Number</label>
						<p class="text-base font-bold">{{models.phoneNumber || '-'}}</p>
					</div>
				</div>
				<div class="w-full lg:w-2/12 flex flex-col justify-evenly my-3 lg:my-0 border-solid border-0 border-grey lg:border-r">
					<div class="field">
						<label class="text-base">Date of Joined</label>
						<p class="text-base font-bold">{{models.dateJoined ? moment(models.dateJoined).format('DD MMMM YYYY') : '-'}}</p>
					</div>
					<div class="field">
						<label class="text-base">Last Activity</label>
						<p class="text-base font-bold">{{models.dateJoined ? moment(models.lastActive).format('DD MMMM YYYY HH:mm') : '-'}}</p>
					</div>
				</div>
				<div class="w-full lg:w-2/12 flex flex-col justify-evenly my-3 lg:my-0">
					<div class="field">
						<label class="text-base">Point Withdraw</label>
						<p class="text-base font-bold">{{models.totalPoint}}</p>
					</div>
					<div class="field">
						<label class="text-base">Point Balance</label>
						<p class="text-base font-bold">{{models.totalCash}}</p>
					</div>
				</div>
			</div>

			<vs-divider />

			<section v-for="(socmed, index) in models.socialMedia" :key="index" :id="socmed.socialMedia" class="social-media">
				<h4 class="font-semibold capitalize">{{socmed.socialMedia}}</h4>
				<div class="w-full my-5 flex flex-col lg:flex-row justify-between">
					<div class="w-full lg:w-4/12 border-solid border-0 border-grey lg:border-r flex items-center">
						<div class="description">
							<h6>{{renderTextPLatform('username', socmed.socialMedia)}}:</h6>
							<h6 class="text-sm my-1 font-bold"><span v-if="['instagram', 'tiktok', 'twitter', 'lemon8', 'threads','shopee'].includes(socmed.socialMedia) && !socmed.username.includes('@')">@</span>{{socmed.username}}</h6>
						</div>
					</div>
					<div class="w-full lg:w-8/12 lg:px-5 flex flex-wrap md:flex-no-wrap md:flex-row mt-2 lg:mt-0">
						<div v-if="socmed.follower" class="w-6/12 grid place-items-center md:mx-1">
							<div class="text-center border border-grey border-solid w-full py-5 rounded-lg">
								<h6 class="text-sm">{{renderTextPLatform('followers', socmed.socialMedia)}}</h6>
								<p class="text-lg font-bold">{{socmed.follower || 0}}</p>
							</div>
						</div>
						<div v-if="socmed.engagement" class="w-6/12 grid place-items-center md:mx-1">
							<div class="text-center border border-grey border-solid w-full py-5 rounded-lg">
								<h6 class="text-sm">Engagement</h6>
								<p class="text-lg font-bold">{{socmed.engagement || 0}}%</p>
							</div>
						</div>
						<div v-if="socmed.link" class="w-full grid place-items-center md:mx-1">
							<div class="text-center border border-grey border-solid w-full py-5 rounded-lg">
								<h6 class="text-sm">Link</h6>
								<a class="text-lg font-bold" :href="socmed.link" target="_blank">{{socmed.link}}</a>
							</div>
						</div>
					</div>
				</div>
			</section>

			<!-- Button Action -->
			<div class="md:w-3/4 mt-20 flex justify-between flex-col md:flex-row m-auto">
				<vs-button v-if="isVerified === null" @click="update('verified', true)" class="w-full mb-3 px-0 lg:mb-0 mx-1 text-center" color="success" type="filled">Approve</vs-button>
				<vs-button v-if="isVerified === null" @click="update('verified', false)" class="w-full mb-3 px-0 lg:mb-0 mx-1 text-center" color="danger" type="filled">Reject</vs-button>
				<vs-button v-if="isVerified" @click="update('account')" class="w-full mb-3 px-0 lg:mb-0 mx-1 text-center" :color="isActiveColor" type="filled">{{isActive ? 'Deactivate' : 'Activate'}}</vs-button>
				<vs-button v-if="isVerified" @click="update('banned')" class="w-full mb-3 px-0 lg:mb-0 mx-1 text-center" :color="isBannedColor" type="filled">{{isBanned ? 'Unbanned ' : 'Banned'}}</vs-button>
				<vs-button v-if="isVerified" @click="update('suspend')" class="w-full mb-3 px-0 lg:mb-0 mx-1 text-center" :color="isSuspendColor" type="filled">{{isSuspend ? 'Unsuspend ' : 'Suspend'}}</vs-button>
				<vs-button class="w-full mb-3 px-0 lg:mb-0 mx-1 text-center" color="rgb(172,172,172)" type="filled" @click="$router.push(redirectURL)">Back</vs-button>
				<vs-button target @click="exportExcel" class="w-full px-0 mx-1" color="primary" type="filled">Export Report</vs-button>

			</div>

			<!-- Change Email Confirmation Popup -->
			<vs-popup button-close-hidden title="Change Email Confirmation" :active.sync="vars.popUpChangeEmailConfirmation">
				<div class="px-5">
					<main class="mb-2">
						<p>Are you sure you want to change the email?</p>
					</main>
					<vs-row vs-w="12">
						<div class="w-1/3 md:w-1/4 pr-1">
							<vs-button class="w-full" type="filled" @click="updateEmail()"
								color="success">Yes</vs-button>
						</div>
						<div class="w-1/3 md:w-1/4">
							<vs-button class="w-full" type="filled"
								color="danger" @click="vars.popUpChangeEmailConfirmation = false">No</vs-button>
						</div>
					</vs-row>
				</div>
			</vs-popup>

			<vs-popup button-close-hidden title="" :active.sync="vars.popUpChangeEmail">
				<div class="px-5">
					<main class="mb-2">
							<label for="reason">Email</label>
							<vs-textarea class="mb-0" v-model="models.emailTemp" v-validate=""
								name="changed_email" />
							<span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email")
							}}</span>
						</main>
						<vs-row vs-w="12">
							<div class="w-1/3 md:w-1/4 pr-1">
								<vs-button class="w-full" type="filled"
									color="success" @click="vars.popUpChangeEmailConfirmation = true">Save</vs-button>
							</div>
							<div class="w-1/3 md:w-1/4">
								<vs-button class="w-full" type="filled"
									color="danger" @click="vars.popUpChangeEmail = false">Cancel</vs-button>
							</div>
						</vs-row>
				</div>
    	</vs-popup>

			
		
		</vs-card>
	</form>
</template>

<script>
	import {getUrlOfFile} from '@/utils/helpers'
	import moment from 'moment'
	import api from '@/utils/api'
	export default {
		name: 'DetailAmbassador',
		data() {
			return {
				vars: {
        	popUpChangeEmail: false,
					popUpChangeEmailConfirmation: false
      	},
				getUrlOfFile,
				config: {
					uri: this.$route.meta.link,
				},
				models: {
					name: '',
					email: '',
					emailTemp: '',
					requestChangeEmail: '',
					bod: '',
          communities: [],
					contentTypes: [],
					address: '',
					province: '',
					phoneNumber: '',
					dateJoined: '',
					lastActive: '',
					totalCash: '',
					totalPoint: '',
					socialMedia: [],
					isBanned: false,
					isSuspend: false,
					isVerified: null,
					isActive: true,
          maritalStatus: '',
          maritalStatusText: '',
				},
				moment
			}
		},
		computed: {
			isVerifiedText() {
				return this.isSuspend ? 'Suspend' : this.isBanned ? 'Banned' : this.models.isVerified === true ? 'Approved' : this.models.isVerified === false ? 'Rejected' : 'Waiting Approval'
			},
			isActive() {
				return this.models.isActive
			},
			isVerified() {
				return this.models.isVerified
			},
			isSuspend() {
				return this.models.isSuspend
			},
			isBanned() {
				return this.models.isBanned
			},
			isBannedColor() {
				return this.models.isBanned ? 'darkBlue' : 'dark'
			},
			isSuspendColor() {
				return this.models.isSuspend ? 'darkGreen' : 'warning'
			},
			isActiveColor() {
				return this.models.isActive ?'danger' : '#22c55e'
			},
			contentTypes() {
				return this.models.contentTypes.map(content => content.name).join(', ')
			},
			redirectURL() {
				return this.$route.params.fromCampaign ? `/campaign/${this.config.fromCampaign}` : '/' + this.config.uri
			}
		},
		created() {
			this.getAmbassador()
			if(this.$route.params.fromCampaign) {
				this.config.fromCampaign = this.$route.params.fromCampaign
			}
		},
		methods: {
			updateEmail() {
				this.$validator.validateAll('changed_email').then((result) => {
					if (result) {
						this.$axios.put(`${api.brandAmbasador}/${this.$route.params.id}/email`, { email: this.models.emailTemp })
							.then(() => {
								this.$refs.response.setResponse({ message: 'Success change email' }, 'success')
								this.vars.popUpChangeEmail = false
								this.vars.popUpChangeEmailConfirmation = false

								// reload
								window.location.reload();
							})
							.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'))
					}
				})
			},
			showPopUp() {
				this.vars.popUpChangeEmail = true;
				this.models.emailTemp = this.models.email
    },
			getAmbassador() {
				if (this.$route.params.id) {
					this.$axios.get(`${api.brandAmbasador}/${this.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							this.models.name = data.name;
							this.models.requestChangeEmail = data.requestChangeEmail;
							this.models.image = data.image;
							this.models.communities = data.communities;
							this.models.bod = data.bod;
							this.models.tier = data.tier;
							this.models.email = data.balance.email;
							this.models.socialMedia = data.socialMedia;
							this.models.contentTypes = data.contentTypes;
							this.models.address = data.address;
							this.models.province = data.province;
							this.models.city = data.city;
							this.models.phoneNumber = data.balance.phoneNumber;
							this.models.dateJoined = data.balance.dateJoined;
							this.models.lastActive = data.balance.lastActive;
							this.models.totalPoint = data.balance.totalPoint;
							this.models.totalCash = data.balance.totalCash;

							this.models.isVerified = data.isVerified;
							this.models.isSuspend = data.isSuspend;
							this.models.isBanned = data.isBanned;
							this.models.isActive = data.account.isActive;

              this.models.maritalStatus = data.maritalStatus;
              this.models.maritalStatusText = data.maritalStatusText;
						}).catch(() => this.$router.push({
							name: 'page404'
						}));
				}
			},

			exportExcel(){
				this.$axios.get(`${api.brandAmbasador}/${this.$route.params.id}/campaign/excel`, {
						responseType: 'blob',
						headers: {
							Authorization: "Bearer " + localStorage.getItem('token')
						}
					}
				).then((response) => {
					const blob = new Blob(
					[response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                    const aEle = document.createElement('a');     // Create a label
                    const href = window.URL.createObjectURL(blob);       // Create downloaded link
                    aEle.href = href;
                    aEle.download = `Report ${this.models.name} (${moment().format('DD MMMM YYYY')})`;  // File name after download
                    document.body.appendChild(aEle);
                    aEle.click();     // Click to download
                    document.body.removeChild(aEle); // Download complete remove element
                    window.URL.revokeObjectURL(href) // Release blob object
				});
			},

			update(action, verified) {
				let data = ''
				switch (action) {
					case 'suspend':
						data = 'isSuspend'
						break;
					case 'banned':
						data = 'isBanned'
						break;
					case 'verified':
						data = 'isVerified'
						break;
					case 'account':
						data = 'isActive'
						break;
					default:
						break;
				}

				let status = Boolean(this[data])

				let nameAction = ''

				switch (action) {
					case 'suspend':
						nameAction = status ? 'unsuspend' : 'suspend'
						break;
					case 'banned':
						nameAction = status ? 'unbanned' : 'banned'
						break;
					case 'verified':
						nameAction = verified ? 'approve' : 'reject'
						break;
					case 'account':
						nameAction = status ? 'deactivate': 'activate'
						break;
					default:
						break;
				}

				if (verified !== undefined) {
					status = verified
				} else {
					status = !status
				}

				if(action === 'banned' && this.isSuspend) {
					this.$axios.patch(`${api.brandAmbasador}/${this.$route.params.id}/suspend`, { status: false })
				} else if(action === 'suspend' && this.isBanned) {
					this.$axios.patch(`${api.brandAmbasador}/${this.$route.params.id}/banned`, { status: false })
				}

				this.$axios.patch(`${api.brandAmbasador}/${this.$route.params.id}/${action}`, { status })
					.then(() => {
						let res = {
							message: `Success ${nameAction} brand ambassador`
						}
						this.$refs.response.setResponse(res, 'success');
						this.getAmbassador()
					})
					.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'))
			},

			renderTextPLatform(type, data) {
				const socmed = data.toLowerCase()
				if(type === 'username') {
					if(socmed === 'youtube') {
						return 'Channel'
					} else {
						return 'Username'
					}
				} else {
					if(['instagram', 'tiktok', 'twitter', 'lemon8', 'threads', 'shopee'].includes(socmed)) {
						return 'Followers'
					} else if (socmed === 'facebook') {
						return 'Friends'
					} else {
						return 'Subscibers'
					}
				}
			}
		}
	}
</script>
